var UitkExpandoTriggerStateMap = [
    ['expand', 'opened'],
    ['collapse', 'closed']
];
var UitkExpandoTriggerStates = new Map(UitkExpandoTriggerStateMap);

export { UitkExpandoTriggerStates };
